import ImagePreloader from 'ImagePreloader';

export default function PreloadedImage({image}) {
  return <img style={{ width: "25vw" }} src={ImagePreloader.images[image].src} />
} 